export default class NotificaionsTemplate {
    id: number;
    name: string;
    title: string;
    importance: string;
    audienceType: string;
    active: boolean;

    constructor(id: number, name: string, title: string, importance: string, audienceType: string, active: boolean) {
        this.id = id;
        this.name = name;
        this.title = title;
        this.importance = importance;
        this.audienceType = audienceType;
        this.active = active;
    }
}